import axios from "axios";
import { APIs } from "../api/api";


const userData = JSON.parse(localStorage.getItem("_2mseamlessTailoring"));
let user = userData?.user;
let token = userData?.token;

const headers = {
  email: user?.email ?? "",
  authorization: token ?? "",
};

export const getTrendingStyles = () => {
  return axios.get(`${APIs.TAILORING.TRENDING_STYLES}`).then((res) => {
    return res;
  });
};

export const getStyleCategories = () => {
  return axios
    .get(`${APIs.TAILORING.STYLES_CATEGORIES}`, { headers })
    .then((res) => res);
};

export const getAllStylesByCategory = (payload) => {
  const { gender, category } = payload;
  return axios.get(
    `${APIs.TAILORING.ALLSTYLES_BY_CATEGORY}?gender=${gender}&category=${category}`
  );
};

export const getAllStylesByGender = (gender) => {
  return axios.get(`${APIs.TAILORING.ALLSTYLES_BY_GENDER}/${gender}`);
};

export const makeTailoringOrder = (payload) => {
  const { id, values, redirect_url } = payload;
  return axios.post(`${APIs.TAILORING.MAKE_TAILORING_ORDER(id)}`, values, {
    headers: { ...headers, redirect_url },
  });
};

export const addToCart = (payload) => {
  const { id, values, } = payload;
  return axios.post(`${APIs.TAILORING.ADD_TO_CART}/${id}`, values, {
    headers: { ...headers },
  });
};

export const viewCart = () => {
  return axios.get(`${APIs.TAILORING.CART}`, {
    headers: {...headers}
  })
}

export const multipleCheckout = (payload) => {
  const {values, redirect_url} = payload
  return axios.post(`${APIs.TAILORING.MULTIPLE_CHECKOUT}`, values, {
    headers: {...headers, redirect_url}
  })
}

export const getOrderDetails = () => {
  return axios.get(`${APIs.TAILORING.ORDER_DETAILS}`, {
    headers: {...headers}
  })
}
export const getSimilarStyles = (cat) => {
  return axios.get(`${APIs.TAILORING.SIMILAR_STYLES(cat)}`, {
    headers: {...headers}
  })
}

export const checkoutCustomStyles = (payload) => {
  const {id, values, redirect_url} = payload
  return axios.post(`${APIs.TAILORING.CUSTOM_CHECKOUT(id)}`, values, {
    headers: {...headers, redirect_url}
  })
}